/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IInternalTraining {
  uuid?: string;
  periodo_referencia?: string;
  data_treinamento: string;
  responsavel_tecnico?: string;
  art?: string;
  participantes?: IParticipantes[];
  id_barragem?: string;
}

export interface IParticipantes {
    uuid?: string;
    profissional?: string;
    empresa?: string;
    cargo?: string;
    responsabilidade_pae?: string;
    id_treinamento?: string;
    id_seminario?: string;
    id_simulado?: string;
}

const create = async (data: IInternalTraining): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('/treinamento', data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao criar novo Treinamento');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar novo Treinamento');
        }
    }
};

const upgrade = async (data: IInternalTraining, uuid: string): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`/treinamento?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao criar novo Treinamento');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar novo Treinamento');
        }
    }
};

const list = async (uuid: string): Promise<IInternalTraining[] | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/treinamentos?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar ACOs');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar ACOs');
        }
    }
};

const get = async (uuid: string): Promise<IInternalTraining | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/treinamento?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar ACO');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar ACO');
        }
    }

};

const delet = async (uuid: string): Promise<string | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete(`/treinamento?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar PAEs');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar PAEs');
        }
    }
};


export const InternalTrainingServices = {
    create,
    list,
    get,
    delet,
    upgrade
};